<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Checkout Reports</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">Checkout Reports</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Users</label
            >
            <!-- <select
              class="select2 m-b-10 select2-multiple"
              style="width: 100%"
              multiple="multiple"
            >
              <option value="">User 01</option>
              <option value="">User 02</option>
              <option value="">User 02</option>
            </select> -->

            <div>
              <Multiselect
                v-model="selectedUsers"
                mode="tags"
                placeholder="Select Users"
                :searchable="true"
                :createTag="true"
                :options="usersList"
              />
            </div>
          </div>

          <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Practices</label
            >
            <!-- <select
              class="select2 m-b-10 select2-multiple"
              style="width: 100%"
              multiple="multiple"
            >
              <option value="">User 01</option>
              <option value="">User 02</option>
              <option value="">User 02</option>
            </select> -->

            <div>
              <Multiselect
                v-model="selectedPractice"
                placeholder="Select Users"
                :searchable="true"
                :createTag="true"
                :options="practices"
              />
            </div>
          </div>

          <!-- <div class="col-sm-4 floating-labels">
            <div class="form-group m-b-40">
              <select class="form-control p-0" id="input6">
                <option></option>
                <option>Powers Pediatrics - Lockhart</option>
                <option>Powers Pediatrics - Daytona</option>
                <option>Powers Family - Tampa</option>
                </select>
              <span class="bar"></span>
              <label for="input6">Locations</label>
            </div>
          </div> -->

          <div class="col-sm-4">
            <input
              style="margin-bottom: 6px; margin-left: 51px"
              type="text"
              name="daterangePR"
              :value="initDatePR"
              @change="datePickerPR"
              @focus="datePickerPR"
            />
            <div class="input-group-append">
              <span
                class="input-group-text"
                style="
                  position: absolute;
                  margin-top: -34px;
                  margin-left: 230px;
                "
              >
                <span class="ti-calendar"></span>
              </span>
            </div>
          </div>

          <!-- <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Date</label
            >
            <div class="input-group mb-3">
              <input
                type="text"
                class="form-control shawCalRanges"
                placeholder="Select Date"
              />
              <div class="input-group-append">
                <span class="input-group-text">
                  <span class="ti-calendar"></span>
                </span>
              </div>
            </div>
          </div> -->
        </div>

        <div class="table-responsive">
          <table
            class="
              table
              display
              table-bordered
              text-center
              table-striped
              no-wrap
            "
            id="table001"
          >
            <thead class="thead-dark">
              <tr>
                <th>Full Name</th>
                <th>Category</th>
                <th>Reasons</th>
                <th>DOS</th>
                <th>Checkout Date</th>
                <th>Checkout User</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(pat, ndx) in patients" :key="ndx">
                <td>{{ pat.name }}</td>
                <td>{{ pat.visitType }}</td>
                <td>{{ pat.visitReason }}</td>
                <td>{{ pat.dosStr }}</td>
                <td>{{ pat.checkoutDateStr }}</td>
                <td>{{ pat.operatorName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Multiselect from "@vueform/multiselect";
// import Swal from "sweetalert2";

export default {
  name: "CheckoutReport",
  components: {
    Multiselect,
  },

  data() {
    return {
      patients: [],
      users: [],
      practices: [],

      usersList: ["A", "B", "C", "D"],
      selectedUsers: [],

      selectedPractice: "",

      startDatePR: "",
      endDatePR: "",
      initDatePR: "",
      dummyDate: moment(String(new Date())).format("YYYY-MM-DD"),
    };
  }, // data

  methods: {
    datePickerPR() {
      const self = this;
      $('input[name="daterangePR"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          self.startDatePR = new Date(start);
          self.endDatePR = new Date(end);
          self.initDatePR =
            self.dateToMDY(self.startDatePR) +
            " - " +
            self.dateToMDY(self.endDatePR);
        }
      );
    },

    loadInit() {
      const dd = new Date();
      dd.setDate(dd.getDate() - 7);

      this.startDatePR = dd;
      this.endDatePR = new Date();
      this.initDatePR =
        this.dateToMDY(this.startDatePR) +
        " - " +
        this.dateToMDY(this.endDatePR);

      this.fetchInitData();
    },

    fetchInitData() {
      this.intDummyComm();
      if (this.selectedUsers.length > 0) {
        let aa = [];
        for (let i = 0; i < this.selectedUsers.length; i++)
          aa.push(this.users[this.selectedUsers[i]].id);
        this.dummyComm.extras = aa.toString();
        //alert(this.selectedUsers.toString() + "    "+this.dummyComm.extras)
      } else this.dummyComm.extras = "";

      if (this.selectedPractice + "".length > 0) {
        this.dummyComm.extras1 = this.selectedPractice;
      } else this.dummyComm.extras1 = "";

      if (this.initDatePR.length > 0) {
        this.dummyComm.myDate = this.dateToSqlServerDateFormat(
          this.startDatePR
        );
        this.dummyComm.myTime = this.dateToSqlServerDateFormat(this.endDatePR);
      } else {
        this.dummyComm.myDate = null;
        this.dummyComm.myTime = null;
      }

      //this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Reports/CheckoutReportInitData";

      this.axiosGetData(url, 1);
    },

    //------------------------------------------ Common Methods
    async axiosGetData(myUrl, what) {
      var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });
      await axios({
        method: "post",
        url: myUrl,
        data: this.dummyComm,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          // if everything goes well -- we will get data
          this.lastErrorCode = 1;
          if (what === 1) {
            console.log(res.data);
            this.users = res.data.users;
            this.patients = res.data.patients;
            this.practices = res.data.practices;

            this.$nextTick(() => {
              $("#table001").DataTable().destroy();
              $("#table001").DataTable({
                  pageLength: 50,
            lengthMenu: [
              [50, 100, 500, 1000, 2000],
              [50, 100, 500, 1000, 2000],
            ],
              });
              $(
                ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
              ).addClass("btn btn-primary mr-1");
              $(".table001").DataTable().draw();
            }); // this.$nextTick
          }
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {});
    }, // axiosGetData
  }, // methods
  computed: {}, // computed

  watch: {
    initDatePR: function () {
      this.fetchInitData();
    },

    selectedUsers: function () {
      this.fetchInitData();
    },

    selectedPractice: function () {
      this.fetchInitData();
    },

    users: function (val) {
      this.usersList = [];
      for (let i = 0; i < val.length; i++) {
        this.usersList.push(val[i].name);
      }
    },

    patients: function (val) {
      for (let i = 0; i < val.length; i++) {
        this.patients[i].dosStr = this.dateToLocalString(this.patients[i].dos);
        this.patients[i].checkoutDateStr = this.dateToLocalString(
          this.patients[i].checkoutDate
        );
      }
    },
  }, //watch

  mounted() {
    this.loadInit();
  }, // mounted
};
</script>

<style>
</style>